import { useContext, useEffect } from "react";
import { INotificationSeverity, NotificationContext } from "@buildwitt/shapeshift-identity";
import useCustomSnackbar from "./useCustomSnackbar";

const useSnackbarManager = () => {
	const {
		successSnackbar,
		errorSnackbar,
		warningSnackbar,
		processInProgressSnackbar,
		infoSnackbar
	} = useCustomSnackbar();
	const {notification} = useContext(NotificationContext);

	useEffect(() => {
		if (notification){
			const { body, title, lifeTime, severity } = notification;
			const multiple = notification.multiple ?? false;
			const message = body ? body : title;

			switch (severity) {
				case INotificationSeverity.success:
					successSnackbar(message, !multiple, lifeTime);
					break;
				case INotificationSeverity.error:
					errorSnackbar(message, !multiple, lifeTime);	
					break;
				case INotificationSeverity.warning:
					warningSnackbar(message, !multiple, lifeTime);	
					break;
				case INotificationSeverity.processInProgress:
					processInProgressSnackbar(message, !multiple);
					break;
				case INotificationSeverity.neutral:
					infoSnackbar(message, !multiple, lifeTime);
					break;
				default:
					break;
			}
		}
	}, [notification]);
}

export default useSnackbarManager;